import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../../../../components/Loading";
import Menu from "../../../../components/Menu";

import api from "../../../../services/api";

const LABEL_TANQUES = [1, 2, 3, 4, 5];

const initialState = {
    tanque: 1,
    tipo: 'E',
    data: new Date(),
    dataf: '',
    inicial: '',
    final: '',
    abastecido: '',
    operador_id: ''
}

export default function Gas() {
    const [counter, setCounter] = useState(1);
    const [form, setForm] = useState({...initialState});
    const [operadores, setOperadores] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [toInsert, setToInsert] = useState([]);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchOperadores = useCallback(() => {
        api.get('operadores').then(response => {
            setOperadores(response.data);
        }).catch(error => {
            setOperadores([]);
        });
    }, []);

    const handleAddItem = () => {
        if (form.inicial === "" || form.final === "" || !form.data || !form.tipo || form.operador_id === '' || !form.operador_id) {
            toast.current.show({ summary: "Aviso", severity: "warn", detail: "Preencha todos os campos para adicionar o registro!" });
            return;
        }

        if(form.tipo === 'E' && form.abastecido === '') {
            toast.current.show({ summary: "Aviso", severity: "warn", detail: "Campo 'abastecido' é obrigatório para o tipo 'Entrada'" });
            return;
        }


        let _toInsert = [...toInsert];
        let _form = { ...form };
        _form.id = counter;
        _form.dataf = String(_form.data.getDate()).padStart(2, "0") + "/" + String(_form.data.getMonth() + 1).padStart(2, "0") + "/" + _form.data.getFullYear();
        let date = _form.data;
        _form.data = _form.data.getFullYear() + "-" + String(_form.data.getMonth() + 1).padStart(2, "0") + "-" + String(_form.data.getDate()).padStart(2, "0");

        if(_form.tipo === 'S')
            _form.abastecido = null;

        _toInsert.push(_form);

        let newForm = { ...initialState };
        newForm.data = date;
        newForm.tanque = _form.tanque;
        newForm.operador_id = _form.operador_id;

        setCounter(counter => counter += 1);
        setForm(newForm);
        setToInsert(_toInsert);
    }

    const handleSubmit = () => {
        setIsLoading(true);

        let copy = toInsert.map(item => ({ ...item }));

        copy.forEach((item) => {
            delete item['dataf'];
            delete item['id'];
        });

        api.post("acabamento/gas", {
            toinsert: copy
        }).then(response => {
            setToInsert([]);
            setIsLoading(false);
            showSuccess(response);
        }).catch(error => {
            setIsLoading(false);
            showError(error);
        });
    }

    useEffect(() => {
        fetchOperadores();
    }, [fetchOperadores]);

    if (isLoading)
        return <Loading />

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-1"
                title="Lançamento - Gás"
            >
                <div className="p-grid p-formgrid p-fluid">
                    <div className="p-col-7">
                        <div className="p-grid p-d-flex p-flex-row">
                            {LABEL_TANQUES.map((label) => (
                                <div className="p-col">
                                    <Button
                                        className={"p-button-secondary p-m-1 " + (form.tanque === label ? "p-button-success" : "")}
                                        key={label}
                                        label={`Tanque ${label}`}
                                        onClick={() => setForm({ ...form, tanque: label })}
                                        style={{ fontSize: 24 }}
                                    />
                                </div>
                            ))}
                        </div>
                        <div className="p-col-12 p-field">
                            <label style={{ fontSize: 24 }} htmlFor="operador_id">Operador: </label>
                            <Dropdown 
                                filter
                                onChange={e => setForm({...form, operador_id: e.value })}
                                options={operadores}
                                optionLabel="nome"
                                optionValue="idoperador"
                                placeholder="-- Selecione o operador --"
                                value={form.operador_id}
                            />
                        </div>
                        <div className="p-col-12 p-field">
                            <label style={{ fontSize: 24 }} htmlFor="data">Data: </label>
                            <Calendar
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                onChange={e => setForm({ ...form, data: e.value })}
                                value={form.data}
                            />
                        </div>
                        <div className="p-col-12 p-field">
                            <label style={{ fontSize: 24 }} htmlFor="tipo">Tipo: </label>
                            <Dropdown
                                onChange={e => setForm({ ...form, tipo: e.value })}
                                options={[
                                    { label: 'Entrada', value: 'E' },
                                    { label: 'Saída', value: 'S' }
                                ]}
                                value={form.tipo}
                            />
                        </div>
                        <div className="p-col-12 p-field">
                            <label style={{ fontSize: 24 }} htmlFor="inicial">Quantidade Inicial: </label>
                            <InputText
                                onChange={e => setForm({ ...form, inicial: e.target.value })}
                                placeholder="4X"
                                type="number"
                                value={form.inicial}
                            />
                        </div>
                        <div className="p-col-12 p-field">
                            <label style={{ fontSize: 24 }} htmlFor="final">Quantidade Final: </label>
                            <InputText
                                onChange={e => setForm({ ...form, final: e.target.value })}
                                placeholder="2Y"
                                type="number"
                                value={form.final}
                            />
                        </div>
                        {form.tipo === 'E' && (
                            <div className="p-col-12 p-field">
                                <label style={{ fontSize: 24 }} htmlFor="abastecido">Abastecido: </label>
                                <InputText
                                    onChange={e => setForm({ ...form, abastecido: e.target.value })}
                                    placeholder="3Z"
                                    type="number"
                                    value={form.abastecido}
                                />
                            </div>
                        )}
                        <div className="p-col-12 p-field">
                            <Button
                                className="p-button-primary"
                                label="Adicionar"
                                onClick={handleAddItem}
                                style={{ fontSize: 24 }}
                            />
                        </div>
                    </div>
                    <div className="p-col-5">
                        <div className="p-grid">
                            <Button
                                className="p-button-success p-mb-2 p-mt-2"
                                label="Salvar"
                                onClick={handleSubmit}
                            />
                        </div>
                        <DataTable
                            emptyMessage="Nenhum registro para lançar"
                            header={"Registros para inserir: " + toInsert.length}
                            responsiveLayout="scroll"
                            size="small"
                            value={toInsert}
                        >
                            <Column header="Tipo" field="tipo" />
                            <Column header="Tanque" field="tanque" bodyStyle={{ fontSize: 20, fontWeight: "bold" }} />
                            <Column header="Data" field="dataf" />
                            <Column header="Inicial" field="inicial" />
                            <Column header="Final" field="final" />
                            <Column header="Abastecido" field="abastecido" />
                            <Column header="Excluir" body={(rowData) => (
                                <div>
                                    <Button
                                        className="p-button-danger"
                                        icon="pi pi-trash"
                                        onClick={() => {
                                            let _toInsert = [...toInsert];
                                            let index = _toInsert.findIndex((element) => {
                                                return parseInt(element.id) === parseInt(rowData.id);
                                            });

                                            _toInsert.splice(index, 1);
                                            setToInsert(_toInsert);
                                        }}
                                        title="Clique para excluir o item"
                                    />
                                </div>
                            )} />
                        </DataTable>
                    </div>
                </div>
            </Card>
        </div>
    )
}